var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cluji-card',{attrs:{"no-header":""}},[_c(_vm.componentInstance,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }